import { render } from "./CalendarRanges.vue?vue&type=template&id=74cafa3d"
import script from "./CalendarRanges.vue?vue&type=script&lang=js"
export * from "./CalendarRanges.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidolmos/Desktop/vue3-daterange-picker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__